/* eslint-disable react/no-string-refs */
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.js";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";
import { IconButton } from "@material-ui/core";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const styles = {
  fileUpload: {
    display: "flex",
  },
};

class FileUploadDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
      toast: false,
      toastMessageType: "",
      toastMessage: "",
    };
    this.fileInputRef = React.createRef();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.previewImage !== this.props.previewImage) {
      this.setState({
        file: null,
        previewUrl: this.props.previewImage || "",
      });
    }
  }
  handleImageChange = (e) => {
    e.preventDefault();
   
    let reader = new FileReader();
    let file = e.target.files[0];
     if (!file) {
    return;
  }
    reader.onloadend = () => {
      if (file.size > 5000000) {
        this.toastUpdate("Error", "File size exceeds 5MB limit.", true);
      } else if (
        this.props.supportedMimeType &&
        this.props.supportedMimeType.indexOf(file.type) === -1
      ) {
        this.toastUpdate("Error", `Unsupported file type. Allowed: ${this.props.supportedMimeType.join(', ')}`, true);
      } else {
        this.setState(
          {
            file: file,
            imagePreviewUrl: file.name,
            previewUrl: reader.result,
          },
          () => this.props.sendFile(file)
        );
      }
    };
    reader.readAsDataURL(file);
  };

  handleClick = () => {
    this.fileInputRef.current.click();
  };

  handleRemove = () => {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
    });
    this.fileInputRef.current.value = null;
    if (this.props.removeFile) {
      this.props.removeFile();
    }
  };

  toastUpdate = (type, message, showToast) => {
    this.setState({
      toast: showToast,
      toastMessage: message,
      toastMessageType: type,
    });
  };

  render() {
    const {
      addButtonProps,
      changeButtonProps,
      removeButtonProps,
      name,
      removeButton,
      noPreview,
      buttonClass,
      localClasses,
      previewImage
    } = this.props;
    const previewSrc =
    this.props.previewImage ??
    this.state.previewUrl;
    const isPdf = previewSrc?.toLowerCase().includes(".pdf") 
      || this.state.file?.type === "application/pdf";
    return (
      <>
        <div
          style={{
            width: "150px",
            height: "200px",
            border: "1px solid #ccc",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "relative",
            margin: "16px 0 0 0",
            cursor:"pointer"
          }}
        onClick={!removeButton ? this.handleClick : undefined}
        role="button"
        >
          <input
            type="file"
            onChange={this.handleImageChange}
            ref={this.fileInputRef}
            style={{
              display: "none"
            }}
          />

          {(this.state.file === null && !previewImage) ? (
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
            >
              <CloudUploadIcon fontSize="large" />
            </IconButton>
          ) : (
            <>
                {isPdf ? (
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 12,
                      textAlign: "center",
                    }}
                  >
                    📄 PDF File
                    <a
                      href={previewSrc}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue", marginTop: 5 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      View PDF
                    </a>
                  </div>
                ) : (
                previewSrc &&
                  <img
                    src={previewSrc}
                    alt="preview"
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      marginBottom: "8px",
                    }}
                  /> 
                )}
            </>
          )}
        </div>
        {(this.state.file !== null || previewImage) && (
          <div style={{
          top: 0,
          right: 4,
          display: "flex",
          gap: "20px",
          maxWidth:"150px",
          justifyContent:"center",
        }}>
            {!name && (
              <IconButton
                color="primary"
                aria-label="edit file"
                component="span"
                onClick={this.handleClick}
              >
                <EditIcon fontSize="medium" />
              </IconButton>
            )}
            {!removeButton && (
              <IconButton
                color="primary"
                aria-label="remove file"
                component="span"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleRemove();
                }}
              >
                <DeleteIcon fontSize="medium" />
              </IconButton>
            )}
          </div>
        )}

        {this.state.toast && (
          <ToastModal
            toastMessage={this.state.toastMessage}
            toastMessageType={this.state.toastMessageType}
            toastUpdate={this.toastUpdate}
          />
        )}
      </>
    );
  }
}

FileUploadDocument.propTypes = {
  avatar: PropTypes.string,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  supportedMimeType: PropTypes.array,
  sendFile: PropTypes.func,
  removeFile: PropTypes.func,
  noPreview: PropTypes.bool,
  name: PropTypes.string,
  removeButton: PropTypes.bool,
  buttonClass: PropTypes.string,
  localClasses: PropTypes.object,
};

export default withStyles(styles)(FileUploadDocument);
